import { useEffect, useRef } from 'react';

// From https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
export default function usePrevious(value) {
  var ref = useRef();
  useEffect(function getPrev() {
    ref.current = value;
  });
  return ref.current;
}
//# sourceMappingURL=usePrevious.js.map